import { Offering, OfferingTransaction, TransactionStatus } from '@arrived/models';

import { canTransactForOffering } from './canTransactForOffering';

export const canFundReservation = (transaction: OfferingTransaction, offering: Offering): boolean => {
  const { status, offeringFull, isHoldShares } = transaction;

  if (status === TransactionStatus.RESERVED) {
    if (isHoldShares) {
      return true;
    }
    return canTransactForOffering(offering) && !offeringFull;
  }
  return false;
};
